import { render, staticRenderFns } from "./Accessories.vue?vue&type=template&id=589bed12&"
import script from "./Accessories.vue?vue&type=script&lang=ts&"
export * from "./Accessories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports